import React, { useEffect, useState } from "react";
import "./runlog.css";
import { DatePicker } from "@fluentui/react-datepicker-compat";
import { DismissFilled } from "@fluentui/react-icons";
import MaterialReactTable, {
  MRT_ColumnDef,
  MRT_PaginationState,
} from "material-react-table";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../../../../redux/store";
import {
  fetchAssystProviderList,
  fetchValuationHistory,
} from "../../../../redux/SystemManager/bulkValuationSlice";
import { formatedDate } from "../../../../utils";
import Multiselectsearch from "../../../../components/MultiSearchDropdown";
import ASCButton from "../../../../components/Button";
import moment from "moment";
import {
  Dialog,
  DialogSurface,
  DialogTitle,
  DialogBody,
  DialogContent,
  DialogActions,
  Button,
  Accordion,
  AccordionItem,
  AccordionHeader,
  AccordionPanel,
} from "@fluentui/react-components";
import { TableListLoader } from "../../../../components/Loader/TableListLoader";

function RunLog() {
  const { valuationHistory, metadata, providers, loading, error } = useSelector(
    (state: RootState) => state.bulkValuation
  );
  const today = new Date();
  const [createdAt, setCreatedAt] = useState<Date | null>(today);
  const [filters, setFilters] = useState({
    createdAt: moment(today).format("YYYY-MM-DD"),
  });
  const [openDialog, setOpenDialog] = useState(false);
  const [selectedRow, setSelectedRow] = useState<any>(null);
  const [rowCount, setRowCount] = useState(0);
  const [valuationDate, setValuationDate] = useState<Date | null>(null);
  const [selectedProvider, setSelectedProvider] = useState<any>([]);
  const [selectedDataProvider, setSelectedDataProvider] = useState<any>([]);
  const [selectedStatus, setSelectedStatus] = useState<any>([]);
  const [pagination, setPagination] = useState<MRT_PaginationState>({
    pageIndex: 0,
    pageSize: 10,
  });

  const dispatch: AppDispatch = useDispatch();

  // Mock data provider list
  const dataProvider = [
    { DataProviderId: "4513b562-9fdd-469b-90a9-7ae2a0940c21", Name: "origo" },
    { DataProviderId: "4513b562-9fdd-469b-90a9-7ae2a0940c22", Name: "finio" },
  ];

  const statusData = [
    { statusId: "success", Name: "Success" },
    { statusId: "failed", Name: "Failed" },
  ];

  const columns: MRT_ColumnDef<any>[] = [
    {
      accessorKey: "CreatedAt",
      header: "Date Processed",
      Cell: ({ row }: any) => <>{formatedDate(row?.original?.CreatedAt)}</>,
    },
    {
      accessorKey: "ValuationDate",
      header: "Value Date",
      Cell: ({ row }: any) => <>{formatedDate(row?.original?.ValuationDate)}</>,
    },
    { accessorKey: "ProviderName", header: "Provider" },
    { accessorKey: "DataProviderName", header: "Data Provider" },
    {
      accessorKey: "CaseRef",
      header: "Provider Reference",
      Cell: ({ row }) => (
        <span
          style={{
            fontWeight: "bold",
            cursor: "pointer",
          }}
          onClick={() => {
            setSelectedRow(row.original);
            setOpenDialog(true);
          }}
        >
          {row.original?.CaseRef}
        </span>
      ),
    },
    { accessorKey: "Status", header: "Status" },
    {
      accessorKey: "StatusDetails",
      header: "Message",
      Cell: ({ row }: any) => {
        let message = "";
        try {
          const details = row.original?.StatusDetails;
          message =
            details?.status_details || details?.error_code_details?.error || "";
        } catch (e) {
          message = "";
        }
        return <>{message}</>;
      },
    },
  ];
  const holderColumns: MRT_ColumnDef<any>[] = [
    { accessorKey: "FirstNames", header: "First Name(s)" },
    { accessorKey: "LastName", header: "Last Name" },
    {
      accessorKey: "DateOfBirth",
      header: "Date of Birth",
      Cell: ({ row }: any) => <>{formatedDate(row?.original?.DateOfBirth)}</>,
    },
  ];

  const advisorColumns: MRT_ColumnDef<any>[] = [
    { accessorKey: "name", header: "Name" },
    { accessorKey: "reference_number", header: "Reference Number" },
  ];
  const customerColumns: MRT_ColumnDef<any>[] = [
    { accessorKey: "_", header: "Full Name" },
    { accessorKey: "xmlns", header: "Last Name" },
  ];

  const fundColumns: MRT_ColumnDef<any>[] = [
    { accessorKey: "FundCode", header: "Fund Code" },
    { accessorKey: "FundCodeSource", header: "Source" },
    { accessorKey: "FundName", header: "Fund Name" },
    { accessorKey: "FundUnits", header: "Units" },
    { accessorKey: "UnitPrice", header: "Price" },
    { accessorKey: "FundValue", header: "Value" },
    { accessorKey: "CurrencyCode", header: "Currency" },
    {
      accessorKey: "PriceDate",
      header: "Date",
      Cell: ({ row }: any) => <>{formatedDate(row?.original?.PriceDate)}</>,
    },
  ];

  const providerOptions =
    providers?.map((provider) => ({
      label: provider.Name,
      value: provider.InvestmentId,
    })) ?? [];

  const dataProviderOptions = dataProvider.map((dp) => ({
    value: dp.DataProviderId,
    label: dp.Name,
  }));

  const statusOptions = statusData.map((st) => ({
    value: st.statusId,
    label: st.Name,
  }));

  const onFormatDate = (date?: Date): string =>
    !date ? "" : moment(date).format("DD-MM-YYYY");

  const getErrorLogs = () => {
    const payload: any = {};

    if (createdAt) {
      payload.createdAt = moment(createdAt).format("YYYY-MM-DD");
    }
    if (valuationDate) {
      payload.valuationDate = moment(valuationDate).format("YYYY-MM-DD");
    }
    if (selectedProvider.length > 0) {
      const provider = providerOptions.find(
        (option) => option.value === selectedProvider[0]
      );
      payload.providerName = provider ? provider.label : selectedProvider[0];
    }
    if (selectedDataProvider.length > 0) {
      const dp = dataProviderOptions.find(
        (option) => option.value === selectedDataProvider[0]
      );
      payload.dataProviderName = dp ? dp.label : selectedDataProvider[0];
    }
    if (selectedStatus.length > 0) {
      const status = statusOptions.find(
        (option) => option.value === selectedStatus[0]
      );
      payload.status = status ? status.value : selectedStatus[0];
    }
    setPagination((prev) => ({ ...prev, pageIndex: 0 }));
    setFilters(payload); // 👈 save filters
  };

  // Initial load
  useEffect(() => {
    const payload = {
      page: pagination.pageIndex + 1,
      limit: pagination.pageSize,
      ...filters, // 👈 merge filters
    };

    dispatch(fetchValuationHistory(payload));
    dispatch(fetchAssystProviderList());
  }, [dispatch, pagination.pageIndex, pagination.pageSize, filters]);

  // Update row count when metadata changes
  useEffect(() => {
    if (metadata?.totalRecords !== undefined) {
      setRowCount(metadata.totalRecords);
    }
  }, [metadata]);

  const parseStatusDetails = (details: string) => {
    try {
      return JSON.parse(details);
    } catch (e) {
      return null;
    }
  };

  const renderStatusDetails = () => {
    if (!selectedRow?.StatusDetails) {
      return <p>No status details available</p>;
    }

    // Parse StatusDetails
    const details = selectedRow?.StatusDetails;
    let parsed = typeof details === "string" ? JSON.parse(details) : details;

    const statusMessage =
      parsed?.status_details || parsed?.error_code_details?.error || "";

    const caseData = parsed?.input_json?.case ?? {};
    const holders = caseData?.holders ?? [];
    const funds = caseData?.funds ?? [];
    const advisers = caseData?.Advisers ?? [];
    const customers = caseData?.Customer ?? [];

    return (
      <Accordion defaultValue={["holders"]} multiple>
        {/* Holders */}
        <AccordionItem value="holders">
          <AccordionHeader>
            <b>Holder(s) Details</b>
          </AccordionHeader>
          <AccordionPanel>
            {holders.length > 0 ? (
              <MaterialReactTable
                columns={holderColumns}
                data={holders.map((h: any) => ({
                  FirstNames: Array.isArray(h.FirstNames)
                    ? h.FirstNames.join(" ")
                    : h.FirstNames || h.customer_full_name?._ || "",
                  LastName: h.LastName || h.customer_full_name?.xmlns || "",
                  DateOfBirth: h.DateOfBirth || "",
                }))}
                enablePagination={false}
                enableColumnActions={false}
                enableSorting={false}
                enableTopToolbar={false}
                enableBottomToolbar={false}
              />
            ) : (
              <p>No holders found</p>
            )}
          </AccordionPanel>
        </AccordionItem>

        {/* Funds */}
        <AccordionItem value="funds">
          <AccordionHeader>
            <b>Funds</b>
          </AccordionHeader>
          <AccordionPanel>
            {funds.length > 0 ? (
              <MaterialReactTable
                columns={fundColumns}
                data={funds}
                enablePagination={false}
                enableColumnActions={false}
                enableSorting={false}
                enableTopToolbar={false}
                enableBottomToolbar={false}
              />
            ) : (
              <p>No funds found</p>
            )}
          </AccordionPanel>
        </AccordionItem>

        {/* Advisers */}
        <AccordionItem value="advisers">
          <AccordionHeader>
            <b>Advisers</b>
          </AccordionHeader>
          <AccordionPanel>
            {advisers.length > 0 ? (
              <MaterialReactTable
                columns={advisorColumns}
                data={advisers}
                enablePagination={false}
                enableColumnActions={false}
                enableSorting={false}
                enableTopToolbar={false}
                enableBottomToolbar={false}
              />
            ) : (
              <p>No advisers found</p>
            )}
          </AccordionPanel>
        </AccordionItem>

        {/* Customers */}
        <AccordionItem value="customers">
          <AccordionHeader>
            <b>Customer(s)</b>
          </AccordionHeader>
          <AccordionPanel>
            {customers.length > 0 ? (
              <MaterialReactTable
                columns={customerColumns}
                data={customers.map((c: any) => ({
                  _: c.customer_full_name?._ || "-",
                  xmlns: c.customer_full_name?.xmlns || "-",
                }))}
                enablePagination={false}
                enableColumnActions={false}
                enableSorting={false}
                enableTopToolbar={false}
                enableBottomToolbar={false}
              />
            ) : (
              <p>No customers found</p>
            )}
          </AccordionPanel>
        </AccordionItem>
      </Accordion>
    );
  };

  return (
    <div className="runlogs">
      {loading ? (
        <TableListLoader rows={10} columns={6} />
      ) : (
        <MaterialReactTable
          columns={columns}
          data={valuationHistory ?? []}
          renderTopToolbarCustomActions={() => (
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                width: "100%",
              }}
            >
              <div className="runlogs_filter">
                {/* Created At Date */}
                <div className="date_picker_filter">
                  <DatePicker
                    value={createdAt}
                    formatDate={onFormatDate}
                    onSelectDate={(date: any) => setCreatedAt(date)}
                    placeholder="Select a Processes Date"
                    name="createdAt"
                    style={{ width: "100%" }}
                  />
                  {createdAt && (
                    <div>
                      <DismissFilled
                        // className="clear_icon"
                        onClick={() => setCreatedAt(null)}
                      />
                    </div>
                  )}
                </div>
                {/* Valuation Date */}
                <div className="date_picker_filter">
                  <DatePicker
                    value={valuationDate}
                    formatDate={onFormatDate}
                    onSelectDate={(date: any) => setValuationDate(date)}
                    placeholder="Select a Value Date"
                    name="valuationDate"
                    style={{ width: "100%" }}
                  />
                  {valuationDate && (
                    <div>
                      <DismissFilled
                        // className="clear_icon"
                        onClick={() => setValuationDate(null)}
                      />
                    </div>
                  )}
                </div>

                {/* Provider */}
                <Multiselectsearch
                  setSelectedDropDownValues={setSelectedProvider}
                  selectedDropDownValues={selectedProvider}
                  placeholder="Select Provider"
                  options={providerOptions}
                  select_all={false}
                  multiselect={false}
                />

                {/* Data Provider */}
                <Multiselectsearch
                  setSelectedDropDownValues={setSelectedDataProvider}
                  selectedDropDownValues={selectedDataProvider}
                  placeholder="Select Data Provider"
                  options={dataProviderOptions}
                  select_all={false}
                  multiselect={false}
                />

                {/* Status */}
                <Multiselectsearch
                  setSelectedDropDownValues={setSelectedStatus}
                  selectedDropDownValues={selectedStatus}
                  placeholder="Status"
                  options={statusOptions}
                  select_all={false}
                  multiselect={false}
                />

                {/* Apply Filter */}
                <ASCButton
                  shape="rounded"
                  appearance="primary"
                  className="asc-button-primary"
                  label="Apply Filter"
                  onClick={getErrorLogs}
                />
              </div>
            </div>
          )}
          enablePagination={true}
          state={{ pagination }}
          rowCount={rowCount}
          onPaginationChange={setPagination}
          manualPagination={true}
        />
      )}
      <Dialog
        open={openDialog}
        onOpenChange={(_, data) => setOpenDialog(data.open)}
      >
        <DialogSurface style={{ maxWidth: "70vw" }}>
          <DialogBody>
            <DialogTitle>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                {selectedRow?.ProviderName} - {selectedRow?.CaseRef}
                <DismissFilled onClick={() => setOpenDialog(false)} />
              </div>
            </DialogTitle>
            <DialogContent>
              <DialogContent>{renderStatusDetails()}</DialogContent>
            </DialogContent>
          </DialogBody>
        </DialogSurface>
      </Dialog>
    </div>
  );
}

export default RunLog;
